<template>
  <validation-observer ref="studentSearchRef" tag="form">
    <div class="rounded bg-gray-1 px-4 py-4">
      <div class="row">
        <div class="col-12 col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.contractNumber"
              custom-error-msg="El número de contrato es requerido."
              :error="errors[0]"
              icon="fas fa-search color-primary-2"
              left-icon
              maxlength="18"
              placeholder="Escriba Número de Contrato"
              type="text"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4 mt-2 mt-md-0">
          <action-button
            i="fas fa-search"
            text="Buscar"
            variant="success px-4"
            @click="onSearchHandler()"
          />
        </div>
        <div
          class="col-12 col-md-4 mt-2 mt-md-0 d-flex align-items-end justify-content-end"
        >
          <action-button
            i="fas fa-times-circle"
            text="Cerrar"
            variant="outline-danger px-4"
            @click="onCloseHandler()"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
//libs components
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';

export default {
  name: 'StudentSearch',
  components: {
    CustomInput,
    ActionButton,
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.model = value;
      },
    },
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit('input', value);
      },
    },
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      contractNumber: null,
    },
  }),
  methods: {
    async onSearchHandler() {
      const isValid = await this.$refs.studentSearchRef.validate();
      if (!isValid) {
        return;
      }
      this.$emit('on-search', this.model);
    },
    onCloseHandler() {
      this.model.contractNumber = null;
      this.$emit('on-close');
    },
  },
};
</script>
